




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { PolicyStatus } from 'admiral-core';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { Util } from '@/utils/Util';
import PolicyStatusBadge from '@/components/common/PolicyStatusBadge.vue';
import { CheckIcon } from 'vue-feather-icons';

@Component({
  components: { PolicyStatusBadge, Multiselect, Avatar, CheckIcon },
})
export default class PolicyStatusSelect extends Vue {
  @Prop({ type: Boolean, default: () => false })
  multiple!: boolean;

  @Prop()
  status!: PolicyStatus | PolicyStatus[];

  get selectableStatus() {
    return [
      PolicyStatus.PLANNED,
      PolicyStatus.OPEN,
      PolicyStatus.SUBMITTED,
      PolicyStatus.POLICED,
      PolicyStatus.DECLINED,
      PolicyStatus.CANCELED,
    ];
  }

  updatePolicyStatus(status: PolicyStatus | PolicyStatus[]) {
    this.$emit('update-policy-status', status);
  }

  formatStatusLabel(status: PolicyStatus) {
    return Util.formatPolicyStatus(status);
  }

  formatStatusClass(status: PolicyStatus) {
    return Util.formatPolicyStatusClass(status);
  }

  isSelected(status: PolicyStatus) {
    if (Array.isArray(this.status)) {
      return this.status.find((s: PolicyStatus) => s === status);
    } else {
      return this.status === status;
    }
  }
}
